/** @format */

/*****************
 **  Root-Saga  **
 *****************/
import { all, fork } from 'redux-saga/effects';
import { loginSaga } from 'stateContainer/sagas/login-saga';
import { logoutSaga } from 'stateContainer/sagas/logout-saga';
import { sendEmailSaga } from 'stateContainer/sagas/send-email-saga';
import { notificationSaga } from './notification-saga';

import { brokerProfileSaga } from 'stateContainer/sagas/broker-profile-saga';
import { brokerProfileBySlugSaga } from 'stateContainer/sagas/broker-profile-by-slug-saga';

import { brokerObjectSaga } from 'stateContainer/sagas/broker-object-saga';
import { brokerObjectsSaga } from 'stateContainer/sagas/broker-objects-saga';
import { brokerObjectsBySlugSaga } from 'stateContainer/sagas/broker-objects-by-slug-saga';

import { moreBrokerObjectsSaga } from 'stateContainer/sagas/more-broker-objects-saga';
import { moreBrokerObjectsBySlugSaga } from 'stateContainer/sagas/more-broker-objects-by-slug-saga';

import { updateBrokerSaga } from 'stateContainer/sagas/update-broker-saga';

const sagas = [
  loginSaga,
  logoutSaga,
  sendEmailSaga,
  updateBrokerSaga,
  notificationSaga,
  brokerProfileSaga,
  brokerProfileBySlugSaga,
  brokerObjectsSaga,
  brokerObjectsBySlugSaga,
  brokerObjectSaga,
  moreBrokerObjectsSaga,
  moreBrokerObjectsBySlugSaga
];

function* rootSaga() {
  const sagaForks = sagas.map((saga) => fork(saga));
  yield all([...sagaForks]);
}

export default rootSaga;
